/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import './NoHu.scss'
import { getApiUrl } from '../../../../api/api'
import Loading from '../../../../component/Loading/Loading'
import {
  getFromlocalstorage,
  getFromsessionstorage
} from '../../../../component/MaHoaDuLieu/MaHoaDuLieu'
import Notify from '../../../../component/Notify/Notify'

const gameData = [
  { name: 'PG', img: '/nohu/newpg.png', GpId: 35 },
  { name: 'JILI', img: '/nohu/jili_s.png', GpId: 1020 },
  { name: 'MW SLOT', img: '/nohu/mw.png', GpId: 1045 },
  { name: 'NS', img: '/nohu/ns.png', GpId: 1066 },
  { name: 'FA CHAI', img: '/nohu/fc.png', GpId: 1046 },
  { name: 'PP', img: '/nohu/pp.png', GpId: 3 },
  { name: 'JDB', img: '/nohu/0.png', GpId: 1058 },
  { name: 'CQ9', img: '/nohu/slot.png', GpId: 2 },
  { name: 'MG SLOT', img: '/nohu/smg.png', GpId: 29 },
  { name: 'FASTSPIN', img: '/nohu/fs.png', GpId: 1079 },
  { name: 'PS', img: '/nohu/ps.png', GpId: 1060 },
  { name: 'YB', img: '/nohu/yb.png', GpId: 1019 },
  { name: 'VA', img: '/nohu/va_s.png', GpId: 1085 },
  { name: 'PA(AG)', img: '/nohu/xin.png', GpId: 1035 },
  { name: 'HB', img: '/nohu/hb.png', GpId: 1031 },
  { name: 'ADVANTPLAY', img: '/nohu/ap.png', GpId: 1034 }
]

const NoHu = () => {
  const [activeTab, setActiveTab] = useState('PG')
  const [datagame, setdatagame] = useState(null)
  const [isLoading, setisLoading] = useState(false)
  const device = window.innerWidth > 540 ? 'd' : 'm'
  const dangnhap = localStorage.getItem('dangnhap')

  const userdata =
    JSON.parse(getFromsessionstorage('data_u')) ||
    JSON.parse(getFromlocalstorage('data_u'))
  const [notiMessage, setNotiMessage] = useState('')

  useEffect(() => {
    handelgame(gameData[0].GpId)
  }, [])

  const handelgame = async GpId => {
    try {
      setisLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/postdanhsachgame`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          GpId
        })
      })
      if (response.ok) {
        const data = await response.json()
        setdatagame(data.seamlessGameProviderGames)
        setisLoading(false)
      }
    } catch (error) {
      setisLoading(false)
      console.error(error)
    }
  }

  const hanldePostWidthdraw = async (gameProviderId, gameId) => {
    try {
      setisLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/launch_game`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          portfolio: 'SeamlessGame',
          device,
          gameProviderId,
          gameId,
          userData: userdata,
          productId: null
        })
      })
      const data = await response.json()
      console.log(data)

      if (data.message) {
        setisLoading(false)
        alert(data.message)
      } else {
        if (data.url) {
          window.location.href = data.url
          setisLoading(false)
        }
      }
    } catch (error) {
      setisLoading(false)
      console.error('Failed to fetch API: ', error)
    }
  }

  return (
    <>
      {notiMessage && (
        <Notify
          message={notiMessage}
          setcontent={setNotiMessage}
          type='error'
        />
      )}

      <div className='dz-box'>
        <Loading isLoading={isLoading} />
        <div className='container wrapdz'>
          <div className='title mb20'>
            <img src='/nohu/title.png' alt='title' />
          </div>

          <div className='tab tab-box tab-row'>
            <div className='tab_ctrl'>
              {gameData.map((item, index) => (
                <button
                  key={index}
                  className={`tab_btn ${
                    activeTab === item.name ? 'active' : ''
                  }`}
                  onClick={() => {
                    handelgame(item.GpId)
                    setActiveTab(item.name)
                  }}
                >
                  <img src={`${item.img}`} alt={item.name} />
                  <span>{item.name}</span>
                </button>
              ))}
            </div>

            <div className='tab_main'>
              <div className='tab_item game-box' style={{ display: 'flex' }}>
                {datagame?.map((item, index) => (
                  <div className='gamebox-dz' key={index}>
                    <a>
                      <div className='hover-cover'>
                        <div className='logo'>
                          <img
                            src={item.gameInfos[0].gameIconUrl}
                            alt={item.gameInfos[0].gameName}
                          />
                        </div>
                        <p
                          className='play-btn'
                          onClick={() => {
                            if (!dangnhap) {
                              setNotiMessage('Vui lòng đăng nhập để chơi game')
                            } else {
                              hanldePostWidthdraw(
                                item.gameProviderId,
                                item.gameID
                              )
                            }
                          }}
                        >
                          Vào trò chơi
                        </p>
                      </div>
                      <p className='name'>{item.gameInfos[0].gameName}</p>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default NoHu
